<div fxLayout="column" fxLayoutAlign="center center" class="w-100 pl-12 pr-12">
    <ui-kit-svg class="i-80" [name]="errorIcon"></ui-kit-svg>
    @if (error) {
        <div class="h3-semi-bold text-center c-primary-gray-900 mt-40 pre-line">
            {{ errorTitle | translate : errorVariables[error] }}
        </div>
    }
    @if (errorSubtitle) {
        <div class="t2 mt-16 pre-line text-center">
            {{ errorSubtitle | translate: {time: (time | uiKitTimerFormat)} }}
        </div>
    }
    @if (requestId) {
        <ui-kit-error-panel></ui-kit-error-panel>
        <div class="t4 mt-24 c-primary-gray-600 pre-line text-center">
            {{ 'i18n_lib_commonErrorErrorCode' | translate: {code: requestId} }}
            <ui-kit-svg matRipple
                        class="i-16 circle pointer ml-8"
                        name="ic_copy"
                        ngxClipboard
                        [matRippleCentered]="true"
                        [matRippleUnbounded]="true"
                        [cbContent]="requestId"/>
        </div>
    }
    @switch (buttonType) {
        @case ('submit') {
            <div class="mt-24">
                <ui-kit-button ngClass.mobile="w-100"
                               type="primary"
                               [label]="submitButtonText | translate"
                               (clickListener)="submit.emit()"/>
            </div>
        }
        @case ('retry') {
            <div class="mt-24">
                <ui-kit-button ngClass.mobile="w-100"
                               type="secondary"
                               [label]="'i18n_auth_retryButton' | translate"
                               (clickListener)="onRetry()"/>
            </div>
        }
        @case ('cameraInstructions') {
            <div class="mt-24">
                <div class="t2 bc-secondary-red-50 p-8 mb-40">
                    <div fxLayout="row" fxLayoutAlign="center center">
                        <ui-kit-svg class="c-secondary-red-800 i-16 mr-4" name="ic_warning_small"></ui-kit-svg>
                        {{ 'i18n_auth_cameraUnavailableRefreshPageWarning1' | translate }}
                    </div>
                    <div class="underline-links"
                         [innerHTML]="'i18n_auth_cameraUnavailableRefreshPageWarning2' | translate | safeHtml"
                         [commonsClickById]="{reloadPage}">
                    </div>
                </div>
                <ui-kit-button ngClass.mobile="w-100"
                               type="secondary"
                               [label]="'i18n_auth_cameraInstructionsButton' | translate"
                               (clickListener)="gotoCameraInstructions()"/>
            </div>
        }
    }
    @if (buttonText) {
        <ui-kit-button class="mt-32"
                       ngClass.mobile="w-100"
                       type="secondary"
                       [label]="buttonText | translate"
                       (clickListener)="close.emit()"/>
    }
    @if (showGoBackButton) {
        <div class="mt-24" fxLayout="column" fxLayoutAlign="center center">
            <ui-kit-button ngClass.mobile="w-100"
                           [type]="buttonType === 'submit' ? 'text' : 'secondary'"
                           [label]="(buttonType === 'submit' ? 'i18n_auth_buttonCancel' : 'i18n_auth_buttonBackNow') | translate"
                           (clickListener)="close.emit()"/>
        </div>
    }
</div>
